/**
 * Prevent unintended form submissions on focus
 * Satisfies WCAG 3.2.1 (On Focus) and 3.2.2 (On Input)
 */
(function() {
  // Flag to track if the submission was triggered by a trusted user event
  let isTrustedSubmission = false;

  // Listen for clicks on submit buttons
  document.addEventListener('click', function(event) {
    const target = event.target;
    if (target.matches('button[type="submit"], input[type="submit"], button:not([type]), .btn-submit, [name="commit"]')) {
      isTrustedSubmission = true;
    }
  }, true);

  // Listen for Enter key on form fields
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      isTrustedSubmission = true;
    }
  }, true);

  // Intercept form submission
  document.addEventListener('submit', function(event) {
    // If the submission is not trusted (e.g., triggered by focus/script), block it
    // event.isTrusted is a native browser property for user-generated events
    if (!isTrustedSubmission && !event.isTrusted) {
      console.warn('Blocked automated form submission on focus/input.');
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Reset the flag for the next potential submission
    setTimeout(() => {
      isTrustedSubmission = false;
    }, 100);
  }, true);

  // Handle dynamically loaded forms (like AJAX carts or popups)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && (node.tagName === 'FORM' || node.querySelector('form'))) {
          // The global listeners handle these automatically
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();